import type { BaseFieldProps } from '@epos/ui';
import { SeeIcon, UnseeIcon } from '@epos/ui/assets';
import { IconButton, TextField } from '@mui/material';

import { useToggle } from '@/hooks/use-toggle';

const PasswordInput: React.FC<BaseFieldProps> = (props) => {
  const { isOpen, toggle } = useToggle();

  return (
    <TextField
      {...props}
      InputProps={{
        endAdornment: (
          <IconButton onClick={toggle} size='small' className='!p-2 [&>svg]:w-6'>
            {isOpen ? <UnseeIcon /> : <SeeIcon />}
          </IconButton>
        )
      }}
      type={isOpen ? 'text' : 'password'}
    />
  );
};

export default PasswordInput;
